import React, { useState, useContext } from 'react';
import './CSS/LoginSignup.css';
import { ShopContext } from '../Context/ShopContext';
import { getApiBaseUrl } from '../config';

const LoginSignup = () => {
    const { mergeCart } = useContext(ShopContext);
    const [state, setState] = useState("Login");
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        confirmPassword: "",
        email: ""
    });

    const changeHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        // Check if fields are empty
        if (!formData.username || !formData.email || !formData.password) {
            alert("All fields are required!");
            return false;
        }

        // Check if email is valid
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailPattern.test(formData.email)) {
            alert("Please enter a valid email address!");
            return false;
        }

        // Check if passwords match
        if (formData.password !== formData.confirmPassword) {
            alert("Passwords do not match!");
            return false;
        }

        // Check password length (optional, can be adjusted)
        if (formData.password.length < 8) {
            alert("Password must be at least 8 characters long!");
            return false;
        }

        return true;
    };    

    const login = async () => {
        console.log("Login Function Executed", formData);
        try {
            const response = await fetch(`${getApiBaseUrl()}/login`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',  // Fix here
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
                credentials: 'include',  // Include credentials (cookies, auth token)
            });
            const responseData = await response.json();
    
            if (responseData.success) {
                localStorage.setItem('auth-token', responseData.token);
                console.log("User logged in, merging cart...");
    
                // Merge local cart with server cart
                await mergeCart();
                console.log("SUCCESSFULLY PASSED ENDPOINT");
    
                // After cart is merged, remove the guest cart from localStorage
                localStorage.removeItem('guestCart');  
    
                // Redirect after merging cart
                window.location.replace("/");
            } else {
                alert(responseData.errors);
            }
        } catch (error) {
            console.error("Error during login:", error);
        }
    };
    
    
    const signup = async () => {
        // Validate form before submitting
        if (!validateForm()) return;

        console.log("Signup Function Executed", formData);
        try {
            const response = await fetch(`${getApiBaseUrl()}/signup`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',  // Fix here
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            const responseData = await response.json();
    
            if (responseData.success) {
                localStorage.setItem('auth-token', responseData.token);
    
                console.log("User signed up, merging cart...");
    
                // Merge local cart with server cart
                await mergeCart();
                
                // After cart is merged, remove the guest cart from localStorage
                localStorage.removeItem('guestCart');  
    
                window.location.replace("/");
            } else {
                alert(responseData.errors);
            }
        } catch (error) {
            console.error("Error during signup:", error);
        }
    };
    

    return (
        <div className="loginsignup">
            <div className="loginsignup-container">
                <h1>{state}</h1>
                <div className="loginsignup-fields">
                    {state === "Sign Up" ? <input name='username' value={formData.username} onChange={changeHandler} type="text" placeholder="Your Name" /> : <></>}
                    <input name='email' value={formData.email} onChange={changeHandler} type="email" placeholder='Email Address' />
                    <input name='password' value={formData.password} onChange={changeHandler} type="password" placeholder='Password' />
                    {state === "Sign Up" && 
                        <input name='confirmPassword' value={formData.confirmPassword} onChange={changeHandler} type="password" placeholder='Confirm Password' />
                    }
                </div>
                <button onClick={() => { state === "Login" ? login() : signup() }}>Continue</button>
                {state === "Sign Up"
                    ? <p className="loginsignup-login">Already have an account? <span onClick={() => { setState("Login") }}>Login here</span></p>
                    : <p className="loginsignup-login">Create an account? <span onClick={() => { setState("Sign Up") }}>Click here</span></p>}
                <div className="loginsignup-agree">
                    <input type="checkbox" name='' id='' />
                    <p>By continuing, I agree to the terms of use & privacy policy.</p>
                </div>
            </div>
        </div>
    );
};

export default LoginSignup;
